export const iconFontAwesomeTransportationCartShopping = (
	<i className="fa-solid fa-cart-shopping"></i>
);
